const DepartmentEnumWithoutLegal = {
    technical: { id: 1, name: "აფეთქების ნებართვა" },
    building: { id: 2, name: "მშენებლობის ნებართვა" },
    administration: { id: 4, name: "ობიექტის რეგისტრაცია" },

};
export default DepartmentEnumWithoutLegal